import axios from 'axios'
import router from './router'

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL || '/api/v1',
  timeout: 150000,
  // 禁用自动重定向，手动处理以保留 Authorization header
  maxRedirects: 0,
  // 允许发送凭证
  withCredentials: true
})

// 请求拦截器
instance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('jwt')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器
instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      const { status } = error.response

      switch (status) {
        case 401:
          localStorage.removeItem('jwt')
          router.push('/login')
          return Promise.reject(new Error('未登录或登录已过期'))

        case 307:
        case 308: {
          // 手动处理重定向，保留 Authorization header
          const redirectUrl = error.response.headers.location
          if (redirectUrl) {
            // 使用原始配置重新发起请求到重定向 URL
            const newConfig = { ...error.config }
            // 如果是相对路径，保持原样；如果是绝对路径，使用完整 URL
            newConfig.url = redirectUrl.startsWith('http') ? redirectUrl : redirectUrl
            return instance(newConfig)
          }
          break
        }
      }
    }
    return Promise.reject(error)
  }
)

export default instance
